import { BaseModel } from './baseModel';

export class SubmissionStep extends BaseModel {
  constructor(
    public name: string = '',
  ) { super(); }
}
